/** Clinical category of the medication */
export enum MedicationCategory {
  /** Labor induction/augmentation agents (e.g. Oxytocin) */
  INDUCTION = 'induction',
  /** Pain management agents (e.g. epidural, fentanyl) */
  PAIN_MGMT = 'pain-mgmt',
  /** Antibiotics (e.g. Penicillin G for GBS prophylaxis) */
  ANTIBIOTIC = 'antibiotic',
  /** Emergency medications */
  EMERGENCY = 'emergency',
}

/** Whether the medication is a one-time dose or continuous administration */
export enum MedicationType {
  /** Single one-time dose */
  BOLUS = 'bolus',
  /** Continuous infusion */
  INFUSION = 'infusion',
}

/** Unit of measurement for the dose */
export enum MedicationUnit {
  MG = 'mg',
  MCG = 'mcg',
  /** Milliunits per minute — used for Pitocin/Oxytocin infusions */
  MU_PER_MIN = 'mU/min',
  ML_PER_HR = 'ml/hr',
}

/** Route of administration */
export enum MedicationRoute {
  /** Intravenous */
  IV = 'iv',
  /** Intramuscular */
  IM = 'im',
  /** Oral */
  PO = 'po',
  EPIDURAL = 'epidural',
}

export interface MedicationLog {
  /** Medication name (e.g. "Oxytocin (Pitocin)", "Terbutaline", "Penicillin G") */
  medName: string
  /** Clinical category of the medication */
  category: MedicationCategory
  /** Bolus (one-time) or Infusion (continuous) */
  type: MedicationType
  /** Numerical dose amount (e.g. 2.5) */
  dose: number
  /** Unit for the dose */
  unit: MedicationUnit
  /** Route of administration */
  route: MedicationRoute
  /** Administration site (e.g. "Left hand IV", "Right Thigh") */
  site: string
  /** Unix timestamp (ms) when administration began */
  startedAt: number
  /** Unix timestamp (ms) when administration stopped — for infusions only */
  stoppedAt?: number
}
